import styled from 'styled-components';

// Layout для всех трех частей (левая колонка, график, правая колонка)
export const Layout = styled.div`
    display: flex;
    width: 100%;
    height: 350px;
    gap: 20px;
    margin-bottom: 10px;
    margin-top: 10px;
`;

// Контейнер для графика
export const ChartBox = styled.div`
    flex: 1;
    min-width: 0;
    height: 350px;
    max-height: 350px;
`;

// Контейнер для колонки легенды
export const LegendContainer = styled.div<{ side: 'left' | 'right' }>`
    flex: 1;
    min-width: 0;
    height: 100%;
    overflow: hidden;
    position: relative;
`;

// Внутренний контейнер с прокруткой
export const LegendInner = styled.div<{ side: 'left' | 'right' }>`
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 10px;

    // Для левой колонки используем RTL чтобы скролл был слева
    direction: ${props => props.side === 'left' ? 'rtl' : 'ltr'};

    // Контент внутри возвращаем к LTR
    & > * {
        direction: ltr;
    }

    // Стилизация скроллбара
    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    // Для Firefox
    scrollbar-width: thin;
    scrollbar-color: #888 #f1f1f1;
`;

// Стили для элементов легенды
export const LegendRow = styled.div`
    display: flex;
    align-items: center;
    padding: 8px 0;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: rgba(0, 0, 0, 0.05);
    }

    &:focus {
        outline: 2px solid #4a90e2;
        outline-offset: 2px;
    }
`;

export const LegendMarker = styled.div`
    width: 16px;
    height: 16px;
    border-radius: 3px;
    margin-right: 8px;
    flex-shrink: 0;
`;

export const LegendCategory = styled.span`
    flex: 1;
    margin-right: 12px;
    font-size: 14px;
    line-height: 1.4;
    word-break: break-word;
`;

export const LegendValue = styled.span`
    margin-right: 8px;
    font-weight: 600;
    font-size: 14px;
    white-space: nowrap;
`;

export const LegendPercent = styled.span`
    font-size: 13px;
    color: #666;
    white-space: nowrap;
    min-width: 45px;
    text-align: right;
`;